import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.25 1.125V12.9375C2.25 13.2539 2.49609 13.5 2.8125 13.5H16.875C17.4727 13.5 18 14.0273 18 14.625C18 15.2578 17.4727 15.75 16.875 15.75H2.8125C1.23047 15.75 0 14.5195 0 12.9375V1.125C0 0.527344 0.492188 0 1.125 0C1.72266 0 2.25 0.527344 2.25 1.125ZM16.5234 4.18359L12.0234 8.68359C11.6016 9.14062 10.8633 9.14062 10.4414 8.68359L8.4375 6.67969L5.27344 9.80859C4.85156 10.2656 4.11328 10.2656 3.69141 9.80859C3.23438 9.38672 3.23438 8.64844 3.69141 8.22656L7.62891 4.28906C8.05078 3.83203 8.78906 3.83203 9.21094 4.28906L11.25 6.29297L14.9414 2.60156C15.3633 2.14453 16.1016 2.14453 16.5234 2.60156C16.9805 3.02344 16.9805 3.76172 16.5234 4.18359Z",
		fill: "currentColor"
	})
});
export default SvgDashboard;
